import { useState, useEffect } from "react";
import "./Recharge.scss";

import rechargeAPI from "../../API/rechargeAPI";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Input } from "reactstrap";
import withdrawAPI from "../../API/withdrawAPI";
import { useSearchParams } from "react-router-dom";
import { Modal } from "antd";
import { baseUrl } from "../../dummy";
import { MdOutlineContentCopy } from "react-icons/md";

const VND = new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
});

function RechargeBank(args) {
    const [selectedValue, setSelectedValue] = useState();
    const [customTab, setCustomTab] = useState(0);
    const [listBank, getListBank] = useState();
    const [modalOne, setModalOne] = useState(false);
    const [money, setMoney] = useState();
    const [noidung, setNoiDung] = useState(sessionStorage.getItem("username"));
    const [settings, setSettings] = useState();

    const [searchParams] = useSearchParams();
    const idPromotion = searchParams.get("id_promotion");

    const handleChange = (event) => {
        setSelectedValue(event);
    };

    useEffect(() => {
        try {
            const fetchListBank = async () => {
                const result = await rechargeAPI.getListBank();
                const dataSettings = await withdrawAPI.getSetting();
                // console.log(dataSettings);
                if (result.status === true) {
                    const { data } = result;
                    getListBank(data);
                }

                if (dataSettings.status === true) {
                    setSettings(dataSettings.data[0]);
                }
            };
            fetchListBank();
        } catch (error) {
            return toast.error("Có lỗi xảy ra!", { theme: "light" });
        }
    }, []);

    const handleClickTHNT = async () => {
        const detailBankArr = [];

        if (!selectedValue) {
            return toast.error("Vui lòng chọn ngân hàng bạn muốn nạp!", {
                theme: "light",
            });
        }

        if (listBank.length > 0) {
            listBank.forEach((item) => {
                if (item.name_bank.toUpperCase() === selectedValue) {
                    detailBankArr.push(item);
                }
            });
        }

        if (!money) {
            return toast.error("Không được để trống!", { theme: "light" });
        }

        if (settings.money_min_receive) {
            if (money < settings.money_min_receive) {
                return toast.error(`Số tiền nạp tối thiểu là ${VND.format(settings.money_min_receive)}!`, {
                    theme: "light",
                });
            }
        }
        try {
            const data = {
                money: money,
                noidung: noidung,
                namebank: selectedValue.name_bank,
                chutk: selectedValue.name_u_bank,
                stk: selectedValue.stk_bank,
                id_km: idPromotion,
            };

            const result = await rechargeAPI.postRecharge(data);
            // console.log(result);

            // setModalOne(false);

            if (result) {
                const { status, message, data } = result;
                toast(message, {
                    theme: "light",
                    type: status ? "success" : "error",
                });
                if (status === true) {
                    setModalOne(true);
                    if (data?.url) window.open(data.url);
                }
            }
        } catch (error) {
            console.log(error);
            return toast.error("Có lỗi xảy ra!", { theme: "light" });
        }
    };

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text);
        toast.success("Sao chép thành công!", { theme: "light" });
    };

    return (
        <>
            <div className="el-tabs__content">
                <div className="el-tab-pane">
                    {/* Nạp tiền qua thẻ ngân hàng */}
                    {customTab === 0 && (
                        <form className="el-form">
                            <div
                                className="el-form-item"
                                style={{ flexDirection: "column" }}
                            >
                                <label
                                    htmlFor="config_index"
                                    className="el-form-item__label"
                                >
                                    Ngân hàng
                                </label>
                                <div
                                    className="el-form-item__content"
                                    style={{}}
                                >
                                    <div
                                        role="radiogroup"
                                        className="el-radio-group bankradio"
                                        style={{ maxWidth: "800px", flexWrap: "wrap", justifyContent: "normal" }}
                                    >
                                        {listBank &&
                                            listBank.map((item) => {
                                                return (
                                                    <label
                                                        className="el-radio"
                                                        style={{ width: "184px", margin: "8px" }}
                                                        onClick={() => handleChange(item)}
                                                        key={item.id}
                                                    >
                                                        <input
                                                            type="radio"
                                                            name="radio"
                                                            value={item.id}
                                                            checked={String(selectedValue?.id) === String(item.id)}
                                                        />
                                                        <span className="checkmark"></span>
                                                        <img
                                                            src={item.icon}
                                                            alt=""
                                                        />
                                                        {item.name_bank.toUpperCase()}
                                                    </label>
                                                );
                                            })}
                                    </div>
                                </div>
                            </div>
                            <div className="el-form-item rechargenotice">
                                <div className="el-form-item__content">
                                    {settings && (
                                        <p className="prompt1">
                                            Mức nạp tiền tối thiểu {VND.format(settings?.money_min_receive)} Tối đa{" "}
                                            {VND.format(settings?.money_max_receive)}
                                        </p>
                                    )}

                                    <p className="prompt2">
                                        Lời nhắc nhở: Chú ý nhập đúng nội dung khi chuyển khoản, phân biệt kí tự viết
                                        hoa hoặc thường, nhập sai không thể lên điểm.
                                    </p>
                                </div>
                            </div>
                            <div className="d-flex align-items-center py-2 gap-4">
                                <span>Số tiền nạp: </span>
                                <Input
                                    className="w-75"
                                    placeholder={`Giới hạn nạp từ ${VND.format(
                                        settings?.money_min_receive,
                                    )} đến ${VND.format(settings?.money_max_receive)}`}
                                    style={{ height: "35px", fontSize: "14px", maxWidth: "600px" }}
                                    onChange={(e) => setMoney(e.target.value)}
                                ></Input>
                            </div>
                            <div className="el-form-item">
                                <div className="el-form-item__content">
                                    <button
                                        type="button"
                                        className="el-button el-button--primary"
                                        onClick={handleClickTHNT}
                                    >
                                        <span>Tiến hành nạp tiền</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    )}
                </div>
            </div>
            <Modal
                open={modalOne}
                onCancel={() => setModalOne(false)}
                footer={null}
                title="Thông tin nạp tiền"
            >
                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex flex-column gap-4 text-2xl">
                        <p className="border-bottom">Số tiền nạp: {VND.format(money)}</p>
                        <p className="border-bottom">Ngân hàng: {selectedValue?.name_bank}</p>
                        <p className="border-bottom">Tên tài khoản: {selectedValue?.name_u_bank}</p>
                        <p className="d-flex align-items-center gap-2 border-bottom">
                            Số tài khoản: {selectedValue?.stk_bank}
                            <span onClick={() => handleCopy(selectedValue?.stk_bank)}>
                                <MdOutlineContentCopy />
                            </span>
                        </p>
                        <p className="border-bottom">Nội dung: {noidung}</p>
                    </div>
                    <img
                        src={`${baseUrl}/${selectedValue?.qr_code}`}
                        alt=""
                    />
                </div>
            </Modal>
            <ToastContainer
                position="top-right"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
}

export default RechargeBank;
